import { render, staticRenderFns } from "./sss_zhuanlan.vue?vue&type=template&id=37d4d6a9&scoped=true"
import script from "./sss_zhuanlan.vue?vue&type=script&lang=js"
export * from "./sss_zhuanlan.vue?vue&type=script&lang=js"
import style0 from "./sss_zhuanlan.vue?vue&type=style&index=0&id=37d4d6a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d4d6a9",
  null
  
)

export default component.exports